import { useEffect, useState } from 'react'
import Question from 'components/layouts/Question/Question';
import QuestionPage from 'components/templates/Questions/QuestionPage';
import {
  useAppDispatch,
  useAppSelector,
} from 'app/hooks';
import {
  resetQuestionsData,
} from 'features/filters/filterSlice';

const Questions = () => {
  
  const dispatch = useAppDispatch();
  const [color, setColor] = useState('blue')

  const toggleFilters = () => {
        
        
    // var element = document.getElementById("question-filter");
    // if (element) element.classList.add("hide");

    var element2 = document.getElementById("sidebar");
    if (element2) element2.classList.add("active");

    // var questionElement = document.getElementById("question-menu");
    var sidebarEement = document.getElementById("sidebar-menu");
    // if(questionElement) {
    //     questionElement.classList.remove("fa-xmark");
    //     questionElement.classList.add("fa-filter");
    // }
    if(sidebarEement) {
        sidebarEement.classList.remove("fa-xmark");
        sidebarEement.classList.add("fa-bars");
    }
}

  useEffect(() => {
    // document.addEventListener('contextmenu', event => event.preventDefault());

    toggleFilters()
    setColor('red')
    dispatch(resetQuestionsData({}));
  }, [])

  return (
    <Question>
      <QuestionPage />
    </Question>
  )
}

export default Questions;